<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item ref="query" :model="query">
            <el-input placeholder="请输入关键字" v-model="query.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_warehouse_add=='true'">
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addwarehouse">新增仓库</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="warning"  @click="checkoutrule">设置出库规则</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->

      <!------------------------add---------------------->
        <el-dialog title="新增仓库" :visible.sync="createDialog">
          <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="medium">
            <el-col :span="14">
              <el-form-item label="仓库名称" prop="name">
                <el-input v-model="create.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="仓库编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="负责人">
                <el-input v-model="create.contact"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="联系电话">
                <el-input v-model="create.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add end---------------------->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading">
          <el-table-column label="仓库名称">
              <template slot-scope="scope">
                  <div class="cz-inventory-warehouse-infos">
                      <img src="../../assets/product_warehouse.png" />
                      <span>{{scope.row.name}}（ID：{{scope.row.id}}）</span>
                  </div>
              </template>
          </el-table-column>
          <el-table-column prop="number" label="编号 - 负责人 - 电话" width="350">
              <template slot-scope="scope">
                  <div style="font-size:13px">{{scope.row.number}}{{!scope.row.contact || scope.row.contact=='' ? '' : ' - '+scope.row.contact}}{{!scope.row.phone || scope.row.phone=='' ? '' : ' - '+scope.row.phone}}</div>
              </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="center" v-if="actionauth.base_warehouse_edit=='true' || actionauth.base_warehouse_del=='true'">
	          <template slot-scope="scope">
	              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editCurrent(scope.row)" v-if="actionauth.base_warehouse_edit=='true'"></el-button>
	              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delCurrent(scope.row)" v-if="actionauth.base_warehouse_del=='true'"></el-button>
	          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
		</div>
      <!------------------------edit---------------------->
        <el-dialog title="编辑仓库信息" :visible.sync="updateDialog">
          <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="medium">
            <el-col :span="24">
              <el-col :span="14">
                <el-form-item label="仓库名称" prop="name">
                  <el-input v-model="update.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="仓库编号" prop="number">
                  <el-input v-model="update.number"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="10">
                <el-form-item label="负责人">
                  <el-input v-model="update.contact"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="联系电话">
                  <el-input v-model="update.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->



      <!------------------------ 查看出库规则列表 ------------------------->
      <el-dialog title="查看出库规则" :visible.sync="setrulequery.dialog" width="55%" top="5vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item ref="query" :model="query">
                  <el-input placeholder="请输入关键字" v-model="setrulequery.keyword" ></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" v-model="setrulequery.keyword" @click="getrulelists">查询</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button type="danger" icon="el-icon-search" @click="addrules">新增</el-button>
              </el-form-item>
          </el-form>

          <div style="margin-top:10px">
              <el-table :data="rulelistss" v-loading="setrulequery.loading">
                <el-table-column label="规则名称" min-width="200">
                    <template slot-scope="scope">
                        <div style="font-size:13px">{{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="是否默认" min-width="120" align="center">
                    <template slot-scope="scope">
                        <div class="warehouse-rule-success" v-if="scope.row.is_default==1">是</div>
                        <div class="warehouse-rule-light" v-if="scope.row.is_default==0">否</div>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间" min-width="150" align="center">
                    <template slot-scope="scope">
                        <div style="font-size:13px">{{scope.row.inputtime}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="210" align="center">
                  <template slot-scope="scope">
                      <el-button type="success" size="small" round @click="settingdefault(scope.row)">设置默认</el-button>
                      <el-button type="warning" size="small" round @click="editrule(scope.row)">编辑</el-button>
                      <el-button type="danger" size="small" round @click="delrule(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block">
              <!--分页begin-->
                <el-pagination
                  @size-change="rulepageSizeChange"
                  @current-change="rulepageCurrentChange"
                  :current-page="setrulequery.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="setrulequery.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="setrulequery.row">
                </el-pagination>
                <!--分页end-->
              </div>
		      </div>
      </el-dialog>
      <!------------------------ 查看出库规则列表 ------------------------->


      <!------------------------ 新增出库规则 ------------------------->
      <el-dialog title="添加出库规则" :visible.sync="addrulequery.dialog" width="35%" top="5vh">
          <div class="warehouse-rule-notice">注：该功能主要针对商品销售出库时批量设置商品的出库仓库信息，商品出库仓库信息为从上至下。即设置排序靠前的仓库先出库，待库存不足时再向下选择仓库进行出库；另：可对下面仓库信息进行拖拽排序</div>
          <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="small">
              <el-form-item label="规则名称">
                  <el-input type="text" v-model="addrulequery.name" />
              </el-form-item>
              <el-form-item label="请选择仓库">
                  <el-select v-model="addrulequery.warehouseids" multiple placeholder="请选择仓库" @change="changerulewarehouse">
                    <el-option v-for="item in tempwarehouselists" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <div class="warehouse-rule-tempinfos" id="warehouse-rule-lists">
              <draggable :list="mywarehouse"  class="wrapper" v-bind="{animation: 200}">
							<transition-group name="list-complete">
								<div class="my-select-warehouse" v-for="(item,index) in mywarehouse" :key="index"  :data-id="item.id" :data-name="item.name"  style="display:inline-block;width:100%">
                    <div class="warehouse-select-names">{{item.id}} - {{item.name}}</div>
                    <div class="warehouse-select-del">
                        <el-button type="danger" size="mini" cirlce icon="el-icon-delete"  @click="delrulequery(index)" />
                    </div>
								</div>
							</transition-group>
						  </draggable>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addrulequery.dialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="addrulequery.loading" @click="saveaddrules">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------ 新增出库规则 ------------------------->





  </div>
  </transition>  
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {draggable},  
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Ware/index",
      transitionshow:true,
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        name:'',
        number:'',
        contact:'',
        phone:''
      },
      updateDialog:false,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        contact:'',
        phone:''
      },

      setrulequery: {
        dialog:false,
        act:'getrulelists',
        token:this.$cookies.get('token'),
        keyword:'',
        ischange:false,
        loading:false,
        p:1,
        rollpage:10,
        row:0,
      },
      rulelistss:[],
      addrulequery: {
          dialog:false,
          act:'addrulequery',
          token:this.$cookies.get('token'),
          loading:false,
          id:'',
          name:'',
          warehouseids:'',
          warehouses:[]
      },
      tempwarehouselists:[],
      mywarehouse:[],


      rules: {
        name: [
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
    }
  },
  mounted(){
    this.getactionauth();
    this.getList();
  },
  methods:{
    
    /** 获取功能操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    addwarehouse() {
    	this.$emit('listenchild',{name:'新增仓库',url:'Warehouseadd'});
    	//this.createDialog = true;
    },
  
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createDialog=false;
                    this.createLoading=false;
                    this.reset();
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createDialog=false;
                  this.createLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    //编辑
    editCurrent(item){
    	this.$emit('listenchild',{name:'编辑仓库',url:'Warehouseedit',data:item});
    	/**
        this.update.id=item.id
        this.update.name=item.name
        this.update.number=item.number
        this.update.contact=item.contact
        this.update.phone=item.phone
        this.updateDialog=true;
        */
    },
    //更新
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //删除
    delCurrent(item){
      this.$confirm('此操作将删除 [' + item.name + '] 所有库存, 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },



    /////////////////////////////////////////////////////////////////
    //出库规则相关

    //设置出库规则
    checkoutrule() {
        this.setrulequery.keyword='';
        this.setrulequery.ischange=false;
        this.setrulequery.p=1;
        this.setrulequery.rollpage=10;
        this.setrulequery.row=0;
        this.setrulequery.dialog=true;
        this.getrulelists();
    },

    //获取出库规则信息列表
    getrulelists() {
        this.setrulequery.loading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.save(this.setrulequery).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.setrulequery.loading=false;
          }else{
            this.setrulequery.loading=false;
            this.rulelistss = JSON.parse(Base64.decode(res.data.Data));
            this.setrulequery.row=parseInt(res.data.count);
            this.rulelistss ? '' : this.rulelistss=[];
            this.setrulequery.row > 0 ? '' : this.setrulequery.row;

            console.log(this.rulelistss);
            console.log(this.setrulequery.row);
            
          }
        }).catch((res) => {
            this.setrulequery.loading=false;
        });   
    },

    rulepageSizeChange(val) {
        this.setrulequery.rollpage = val;
        this.getrulelists();
    },
    rulepageCurrentChange(val) {
        this.setrulequery.p = val;
        this.getrulelists();
    },


    //新增出库规则
    addrules() {
        this.addrulequery.id='';
        this.addrulequery.name='';
        this.addrulequery.act='addrulequery';
        this.addrulequery.warehouseids=[];
        this.addrulequery.warehourse=[];
        this.mywarehouse=[];
        this.addrulequery.dialog=true;
        //刷新当前仓库数据
        this.gettempwarehouselists();
    },


    //获取待确认仓库信息列表
    gettempwarehouselists() {
        var resource = this.$resource(this.url);
        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage: 1000000}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
            this.tempwarehouselists = JSON.parse(Base64.decode(res.data.Data));
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },  


    //修改选中的仓库信息
    changerulewarehouse() {
        this.mywarehouse=[];
        for(var i=0;i<this.tempwarehouselists.length;i++) {
           for(var ii=0;ii<this.addrulequery.warehouseids.length;ii++) {
              if(this.tempwarehouselists[i].id==this.addrulequery.warehouseids[ii]) {
                  this.mywarehouse.push({id:this.tempwarehouselists[i].id,name:this.tempwarehouselists[i].name});
              }
           }
        }
        console(this.mywarehouse);
    },

    //删除选中的仓库
    delrulequery(index) {
        this.$delete(this.addrulequery.warehouseids,index);
        this.changerulewarehouse();
    },


    //保存出库规则
    saveaddrules() {
        this.getruledetails(); //获取排序后的仓库信息
        this.addrulequery.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.addrulequery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.addrulequery.loading=false;
          }else{
              this.addrulequery.loading=false;
              this.addrulequery.dialog=false;
              //刷新当前仓库数据
              this.getrulelists();
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addrulequery.loading=false;

        });
    },


    getruledetails() {
        this.mywarehouse.length > 0 ? this.addrulequery.warehouses=this.mywarehouse : this.addrulequery.warehouses=[];
    },  


    //设置默认规则
    settingdefault(item) {
        var resource = this.$resource(this.url);
        resource.query({act:'changedefault',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.getrulelists();
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    //删除规则
    delrule(item) {
        this.$confirm('您是否要删除该出库规则?', '提示', { type: 'warning' }).then(() => {
            
            var resource = this.$resource(this.url);
            resource.query({act:'delrule',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.getrulelists();
                }
            }).catch((res) => {
                this.$message.error(this.GLOBAL.errortext);
            });

        }).catch(() => {
              
        });
    },

    //获取出库规则
    editrule(item) {
        var resource = this.$resource(this.url);
        resource.query({act:'getruleinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.addrulequery.id=item.id;
                this.addrulequery.name=result.name;
                this.addrulequery.act='editrulequery';
                this.addrulequery.warehouseids=[];
                this.addrulequery.warehourse=result.values;
                this.mywarehouse=result.values;
                for(var i=0;i<result.values.length;i++) {
                    this.addrulequery.warehouseids.push(result.values[i].id);
                }
                this.addrulequery.dialog=true;

                //刷新当前仓库数据
                this.gettempwarehouselists();

            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    //出库规则相关
    //////////////////////////////////////////////////////////////////////



  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}

.cz-inventory-warehouse-infos {display:flex;justify-content:left;align-items:center;width:100%}
.cz-inventory-warehouse-infos img {width:20px;height:20px;}
.cz-inventory-warehouse-infos span {font-size:13px;margin-left:10px;}

.warehouse-rule-success,.warehouse-rule-light {font-size:12px;line-height:15px;padding:2px 10px;border-radius:15px;display:inline-block;}
.warehouse-rule-light {background:#C0C4CC;color:#fff;border:1px solid #C0C4CC;}
.warehouse-rule-success {background:#67C23A;color:#fff;border:1px solid #67C23A;}
.warehouse-rule-notice {display:inline-block;width:calc(100% - 20px);background:#EBEEF5;color:#F56C6C;font-size:12px;line-height:21px;padding:10px;border-radius:6px;margin-bottom:20px;}
.warehouse-rule-tempinfos {display:inline-block;width:100%;margin-top:20px;border-top:1px solid #EBEEF5;padding-top:20px;}
.warehouse-select-names {display:inline-block;font-size:12px;line-height:21px;padding:5px 20px;border-radius:15px;float:left;letter-spacing:1px;}
.warehouse-select-del {display:inline-block;float:right;}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Warehouse.vue